<template>
  <div
    :class="
      formDisabled
        ? 'adult-exam-apply-disabled adult-exam-apply'
        : 'adult-exam-apply'
    "
  >
    <div class="check-status" v-if="checkStatus">
      {{ statusName }}

      <span v-if="statusReason">，原因：{{ statusReason }}</span>
    </div>
    <el-form
      class="apply-form"
      :model="form"
      :rules="rules"
      ref="form"
      :disabled="formDisabled"
    >
      <div class="box">
        <el-form-item prop="name">
          <img
            class="icon"
            src="../../assets/images/icons/apply-form-icon-2.png"
          />
          <el-input v-model="form.name" placeholder="学员姓名"></el-input>
        </el-form-item>
        <el-form-item prop="birthday">
          <img
            class="icon"
            src="../../assets/images/icons/apply-form-icon-1.png"
          />
          <el-date-picker
            v-model="form.birthday"
            type="date"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            placeholder="出生日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item prop="sex">
          <img
            class="icon"
            src="../../assets/images/icons/apply-form-icon-3.png"
          />
          <el-select v-model="form.sex" placeholder="性别">
            <el-option label="男" value="2"></el-option>
            <el-option label="女" value="1"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item prop="apply_school">
            <img
              class="icon"
              src="../../assets/images/icons/apply-form-icon-4.png"
            />
            <el-input
              v-model="form.apply_school"
              placeholder="报考院校"
            ></el-input>
          </el-form-item> -->
      </div>
      <div class="box selected">
        <el-form-item prop="education">
          <!-- <el-select v-model="form.education" placeholder="最高学历">
              <el-option value="初中及以下" label="初中及以下"></el-option>
              <el-option value="高中" label="高中"></el-option>
              <el-option value="大专" label="大专"></el-option>
              <el-option value="本科及其以上" label="本科及其以上"></el-option>
            </el-select> -->
          <el-select v-model="form.education" placeholder="最高学历">
            <el-option
              v-for="(item, index) in educationLevels"
              :value="item.key"
              :label="item.value"
              :key="index"
            ></el-option>
          </el-select>
          <div class="select-icon"></div>
        </el-form-item>
        <el-form-item prop="education_check">
          <el-select
            v-model="form.education_check"
            placeholder="学历是否学信网可查"
          >
            <el-option value="1" label="是"></el-option>
            <el-option value="0" label="否"></el-option>
          </el-select>
          <div class="select-icon"></div>
        </el-form-item>

        <el-form-item prop="apply_type">
          <el-select v-model="form.apply_type" placeholder="报考证书类型">
            <el-option
              label="初级经济师证书"
              value="初级经济师证书"
            ></el-option>
            <el-option
              label="中级经济师证书"
              value="中级经济师证书"
            ></el-option>
          </el-select>
          <div class="select-icon"></div>
        </el-form-item>

        <el-form-item v-if="isShowPrimaryCert" prop="is_primary_cert">
          <el-select
            v-model="form.is_primary_cert"
            placeholder="是否取得初级证书"
          >
            <el-option value="1" label="是"></el-option>
            <el-option value="0" label="否"></el-option>
          </el-select>
          <div class="select-icon"></div>
        </el-form-item>
        <el-form-item prop="is_graduation">
          <el-select v-model="form.is_graduation" placeholder="是否有毕业证">
            <el-option value="1" label="是"></el-option>
            <el-option value="0" label="否"></el-option>
          </el-select>
          <div class="select-icon"></div>
          <!-- <div
              class="meaasge"
              v-if="form.is_graduation && Number(form.is_graduation) === 0"
            >
              不满足报考条件
            </div> -->
        </el-form-item>
        <el-form-item class="upload" v-if="form.is_graduation === '1'">
          <el-upload
            class="upload-demo"
            :on-success="
              (response) => {
                onUploadSuccess('graduation_certificate_image', response)
              }
            "
            :on-remove="
              () => {
                handleRemove('graduation_certificate_image')
              }
            "
            :on-error="handleErr"
            name="FileName"
            multiple
            type="file"
            :limit="1"
            :file-list="fileList.certificate"
            :action="uploadUrl"
          >
            <el-button size="small" type="primary">上传毕业证</el-button>
          </el-upload>
        </el-form-item>
      </div>
      <div class="box selected">
        <el-form-item prop="province">
          <el-select v-model="form.province" filterable placeholder="户籍省份">
            <el-option
              v-for="(item, index) in provinceList"
              :value="item.provinceNo"
              :label="item.provinceName"
              :key="index"
            ></el-option>
          </el-select>
          <div class="select-icon"></div>
        </el-form-item>
        <el-form-item prop="apply_province">
          <el-select
            v-model="form.apply_province"
            filterable
            placeholder="报考省份"
          >
            <el-option
              v-for="(item, index) in provinceList"
              :value="item.provinceNo"
              :label="item.provinceName"
              :key="index"
            ></el-option>
          </el-select>
          <div class="select-icon"></div>
        </el-form-item>
        <!-- <el-form-item v-if="form.province !== form.apply_province">
            <el-select v-model="form.is_live_card" placeholder="报考省份居住证">
              <el-option value="1" label="有"></el-option>
              <el-option value="0" label="无"></el-option>
            </el-select>
            <div class="select-icon"></div>
            <div
              class="meaasge"
              v-if="form.is_live_card && Number(form.is_live_card) === 0"
            >
              不满足报考条件
            </div>
          </el-form-item>
          <el-form-item
            class="upload"
            v-if="form.province !== form.apply_province"
          >
            <el-upload
              class="upload-demo"
              :on-success="
                (response) => {
                  onUploadSuccess('live_card_image', response)
                }
              "
              :on-remove="
                () => {
                  handleRemove('live_card_image')
                }
              "
              name="FileName"
              multiple
              type="file"
              :limit="1"
              :action="uploadUrl"
              :file-list="fileList.card"
            >
              <el-button size="small" type="primary">上传居住证</el-button>
            </el-upload>
          </el-form-item> -->
        <el-form-item prop="work_year">
          <el-select v-model="form.work_year" placeholder="工作年限">
            <el-option label="4年以下" value="4年以下"></el-option>
            <el-option label="4年-5年" value="4年-5年"></el-option>
            <el-option label="6年-9年" value="6年-9年"></el-option>
            <el-option label="10年及以上" value="10年及以上"></el-option>
          </el-select>
          <div class="select-icon"></div>
        </el-form-item>
        <el-form-item prop="is_work_card">
          <el-select
            v-model="form.is_work_card"
            placeholder="是否能提供工作/社保证明"
          >
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
          <div class="select-icon"></div>
        </el-form-item>
        <el-checkbox
          v-if="!checkStatus"
          v-model="form.is_agreed"
          class="form-is-agree"
        >
          我承诺以上信息均属实，若因造假导致相关问题由本人负责。
        </el-checkbox>
      </div>
    </el-form>
    <el-button
      type="primary"
      class="save-btn"
      @click="save"
      :disabled="formDisabled || form.is_agreed === false"
    >
      保存
    </el-button>
  </div>
</template>

<script>
import Vue from 'vue'
import { getCookie } from '@/utils/utils'
import {
  UPLOAD_URL,
  getProvinces,
  adultexamApply,
  adultexamApplyInfo,
  getEducationLevels,
} from '@/server/me'
export default {
  data() {
    return {
      form: {
        sex: '',
        name: '',
        birthday: '',
        education: '',
        is_graduation: '',
        graduation_certificate_image: '',
        province: '',
        apply_province: '',
        apply_type: '',
        work_year: '',
        is_work_card: '',
        is_primary_cert: '',
        is_agreed: false,
      },
      statusName: '',
      statusReason: '',
      checkStatus: false,
      provinceList: [],
      educationLevels: [],
      uploadUrl: '',
      rules: {
        sex: [
          {
            required: true,
            message: '请选择性别',
            trigger: 'change',
          },
        ],
        name: [
          {
            required: true,
            message: '请输入学员姓名',
            trigger: 'blur',
          },
        ],
        birthday: [
          {
            required: true,
            message: '请选择出生日期',
            trigger: 'change',
          },
        ],
        education: [
          {
            required: true,
            message: '请选择最高学历',
            trigger: 'change',
          },
        ],
        is_graduation: [
          {
            required: true,
            message: '请选择是否有毕业证',
            trigger: 'change',
          },
        ],
        work_year: [
          {
            required: true,
            message: '请选择工作年限',
            trigger: 'change',
          },
        ],
        apply_type: [
          {
            required: true,
            message: '请选择证书类型',
            trigger: 'change',
          },
        ],
        is_primary_cert: [
          {
            required: this.isShowPrimaryCert ? true : false,
            message: '请选择是否有初级证书',
            trigger: 'change',
          },
        ],
        province: [
          {
            required: true,
            message: '请选择户籍省份',
            trigger: 'change',
          },
        ],
        apply_province: [
          {
            required: true,
            message: '请选择报考省份',
            trigger: 'change',
          },
        ],
        is_work_card: [
          {
            required: true,
            message: '请选择是否能提供工作/社保证明',
            trigger: 'change',
          },
        ],
      },
      formDisabled: false,
      fileList: {
        certificate: [],
        card: [],
      },
    }
  },
  computed: {
    isShowPrimaryCert() {
      return (
        this.form.apply_type === '中级经济师证书' &&
        this.form.education.indexOf('高中') >= 0
      )
    },
  },
  mounted() {
    let userId = getCookie('uid')
    let sessionKey = getCookie('sessionkey')
    this.uploadUrl =
      UPLOAD_URL + '&userId=' + userId + '&sessionKey=' + sessionKey
    this.getProvincesHandler()
    this.getApplyInfo()
    this.getEducations()
  },
  methods: {
    onUploadSuccess(type, response) {
      const { code = 1, msg = '', data = '' } = response
      if (code === 0) {
        this.form[type] = data
        this.$message({
          message: '上传成功',
          type: 'success',
        })
      } else {
        this.$message.error(msg)
        this.$message({
          message: '删除成功',
          type: 'success',
        })
      }
    },
    handleRemove(type) {
      this.form[type] = ''
    },
    handleErr() {
      this.$message.error('上传失败')
    },
    async getProvincesHandler() {
      const { code = 1, msg = '', ...res } = await getProvinces()
      if (code === 0) {
        const {
          data: { provinces = [] },
        } = res
        this.provinceList = provinces
      }
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          if (this.isShowPrimaryCert) {
            if (this.form.is_primary_cert === '') {
              this.$message.error('请选择是否有初级证书')
              return
            }
          } else {
            this.form.is_primary_cert = ''
          }
          const { code = 1, msg = '', data = {} } = await adultexamApply(
            this.form,
          )
          if (code === 0) {
            this.$message({
              message: '提交成功',
              type: 'success',
              onClose: () => {
                this.getApplyInfo()
              },
            })
          } else {
            this.$message.error(msg)
          }
        }
      })
    },
    async getApplyInfo() {
      const { code = 1, msg = '', data = {} } = await adultexamApplyInfo()
      if (code === 0 && data.education) {
        if (typeof data.status === 'number') {
          this.checkStatus = true
          this.statusName = data.status_name
          if (Number(data.status) === 2) this.statusReason = data.reason
          if (Number(data.status) === 1) this.formDisabled = true
        }
        data.is_graduation = String(data.is_graduation)
        data.is_primary_cert =
          data.is_primary_cert === null ? '' : String(data.is_primary_cert)
        data.is_work_card = String(data.is_work_card)
        data.education_check = String(data.education_check)
        data.sex = String(data.sex)
        // data.is_live_card = String(data.is_live_card)
        this.form = data
        if (data.graduation_certificate_image) {
          this.fileList.certificate = [
            {
              name: '毕业证',
              url: data.graduation_certificate_image,
            },
          ]
        }
      }
    },
    async getEducations() {
      const { code = 1, msg = '', data = {} } = await getEducationLevels()
      if (code === 0) {
        const keys = Object.keys(data)
        keys.map((key) => {
          this.educationLevels.push({
            key: key,
            value: data.key,
          })
        })
      }
    },
  },
}
</script>

<style lang="scss" src="./scss/index.scss"></style>



// WEBPACK FOOTER //
// src/views/adultExamApply/index.vue